import React from 'react';
import styled from 'styled-components'

const Article6Block = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  margin: 0px auto;
  position: relative;
  video {
    width: 100%;
  }
  position:relative;
  z-index: 0;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    z-index: 1;
  }
  .flexText {
    position: absolute;
    top: 0; left: 50%;
    transform: translateX(-50%);
    padding: 50px 0;
    display: flex;
    justify-content: center;
    z-index: 99999;
    img {width:100px;}
  }
  .textBox {
    position: absolute;
    top: 50%; left: 50%;
    margin-top: 20vh;
    transform: translate(-50%,-50%);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    z-index: 99999;
    p {
      text-align: center;
      font-family: 'Josefin Sans';
      font-size: 50px;
      font-weight: 700;
      line-height: 1.5em;
    }
    a{
      text-align: center;
      img{
        width: 400px;
      }
    }
  }
`;

const Article6 = () => {
  return (
    <Article6Block>
      <video playsInline={true} autoPlay={true} loop={true} muted={true}>
        <source src="videos/lastSection.mp4" type="video/mp4" />
      </video>
      <div className='flexText'>
        <img src="images/s_sticker.gif" alt="s" />
        <img src="images/t_sticker.gif" alt="t" />
        <img src="images/u_sticker.gif" alt="u" />
        <img src="images/s_sticker.gif" alt="s" />
        <img src="images/s_sticker.gif" alt="s" />
        <img src="images/y_sticker.gif" alt="y" />
      </div>
      <div className='textBox'>
        <p>If you are interested in Stussy,<br/>click the logo and enjoy shopping</p>
        <a href="https://www.stussy.co.kr" target="_blank">
          <img src="images/stussylogogif.gif" alt='logo'/>
        </a>
      </div>
    </Article6Block>
  );
};

export default Article6;